// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_page {
	padding: 30px
}

.chartjs-render-monitor {
	/* max-width: 300px;
	max-height: 250px;
	min-width: 300px;
    min-height: 250px; */
}

.dashboard_hrzone-container {
	background: #fff;
	width: 100%;
	min-height: 250px;


	display: grid;
	grid-template-columns: 1fr 6fr 1fr;
	position: relative;

}

.dashboard_card {
	border-radius: 15px;
	background: #fff;
	padding: 10px 20px;
	height: -moz-fit-content;
	height: fit-content;
	min-height: 97px;
	min-width: 220px;

	position: relative;
	width: 100%;

	margin: auto;

	display: flex;
	justify-content: space-between;
	align-items: center;
}


.dashboard_employee-border {
	border-right: 1px solid #A8A8A8;
}

.dashboard_employee-container {
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin-top: 30px;
}

.dashboard_dot-container {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
}

.dashboard_employee-dot {
	width: 15px;
	height: 15px;
	border-radius: 100%;
	background: #f8542b;
	margin-Right: 15px;
}



.dashboard_category-container {
	display: grid;
	grid-template-columns: 1fr 3fr;
	padding: 30px
}

.dashboard_cards-container {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	column-gap: 20px;
	row-gap: 20px;
	height: -moz-fit-content;
	height: fit-content;
	margin: auto;
	width: 95%
}

.dashboard_card-image {
	width: 60px;
	height: 60px;

}

.dashboard_card-textContainer {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
}


.card_text {
	margin-bottom: 8px;
	font-size: 12px
}

.card_text-percentage {
	font-size: 22px;
	font-weight: 700
}

.dashboard_category-circle {
	width: 300px;
	height: 300px;
	margin: auto;
	display: flex;
	align-items: center;
}

.dasboard_employee-circle {
	width: 260px;
	height: 260px
}

.dashboard_employee-button {
	display: flex;
	align-items: flex-end;
	justify-content: center;
	flex-direction: column;
}


@media (max-width: 1410px) {
	.dashboard_cards-container {
		grid-template-columns: 1fr 1fr 1fr;
	}
}

@media (max-width: 1300px) {
	.dashboard_cards-container {
		grid-template-columns: 1fr 1fr;
	}

	.dashboard_hrzone-container {
		grid-template-columns: 1fr;
	}

	.dasboard_employee-circle {
		margin: auto;
		margin-bottom: 30px
	}

	.dashboard_employee-button {
		margin: auto;
		display: block;
		margin-top: 30px;
		min-width: 200px
	}
}

@media (max-width: 900px) {
	.dashboard_cards-container {
		grid-template-columns: 1fr 1fr 1fr;
	}

	.dashboard_category-container {
		grid-template-columns: 1fr;
	}

	.dashboard_category-circle {
		margin: 0 auto 30px auto;
	}

	.dashboard_employee-border {
		border-right: none;

	}
}

@media (max-width: 768px) {
	.dashboard_cards-container {
		grid-template-columns: 1fr 1fr;
	}

	.dashboard_employee-container {
		grid-template-columns: 1fr;
		margin-top: 30px;
	}

	.dashboard_employee-border {

		margin-bottom: 30px;
	}
}


@media (max-width: 550px) {
	.dashboard_cards-container {
		grid-template-columns: 1fr;
		width: 100%
	}

}`, "",{"version":3,"sources":["webpack://./src/pages/hrzone/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;CACC;AACD;;AAEA;CACC;;;wBAGuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,iBAAiB;;;CAGjB,aAAa;CACb,kCAAkC;CAClC,kBAAkB;;AAEnB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,wBAAmB;CAAnB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;;CAEhB,kBAAkB;CAClB,WAAW;;CAEX,YAAY;;CAEZ,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;;AAGA;CACC,+BAA+B;AAChC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;AACnB;;;;AAIA;CACC,aAAa;CACb,8BAA8B;CAC9B;AACD;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,gBAAgB;CAChB,aAAa;CACb,wBAAmB;CAAnB,mBAAmB;CACnB,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX,YAAY;;AAEb;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,6BAA6B;AAC9B;;;AAGA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,uBAAuB;CACvB,sBAAsB;AACvB;;;AAGA;CACC;EACC,kCAAkC;CACnC;AACD;;AAEA;CACC;EACC,8BAA8B;CAC/B;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,YAAY;EACZ;CACD;;CAEA;EACC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC;EACC,kCAAkC;CACnC;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,kBAAkB;;CAEnB;AACD;;AAEA;CACC;EACC,8BAA8B;CAC/B;;CAEA;EACC,0BAA0B;EAC1B,gBAAgB;CACjB;;CAEA;;EAEC,mBAAmB;CACpB;AACD;;;AAGA;CACC;EACC,0BAA0B;EAC1B;CACD;;AAED","sourcesContent":[".dashboard_page {\n\tpadding: 30px\n}\n\n.chartjs-render-monitor {\n\t/* max-width: 300px;\n\tmax-height: 250px;\n\tmin-width: 300px;\n    min-height: 250px; */\n}\n\n.dashboard_hrzone-container {\n\tbackground: #fff;\n\twidth: 100%;\n\tmin-height: 250px;\n\n\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 6fr 1fr;\n\tposition: relative;\n\n}\n\n.dashboard_card {\n\tborder-radius: 15px;\n\tbackground: #fff;\n\tpadding: 10px 20px;\n\theight: fit-content;\n\tmin-height: 97px;\n\tmin-width: 220px;\n\n\tposition: relative;\n\twidth: 100%;\n\n\tmargin: auto;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n\n.dashboard_employee-border {\n\tborder-right: 1px solid #A8A8A8;\n}\n\n.dashboard_employee-container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tmargin-top: 30px;\n}\n\n.dashboard_dot-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 20px;\n}\n\n.dashboard_employee-dot {\n\twidth: 15px;\n\theight: 15px;\n\tborder-radius: 100%;\n\tbackground: #f8542b;\n\tmargin-Right: 15px;\n}\n\n\n\n.dashboard_category-container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 3fr;\n\tpadding: 30px\n}\n\n.dashboard_cards-container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr 1fr;\n\tcolumn-gap: 20px;\n\trow-gap: 20px;\n\theight: fit-content;\n\tmargin: auto;\n\twidth: 95%\n}\n\n.dashboard_card-image {\n\twidth: 60px;\n\theight: 60px;\n\n}\n\n.dashboard_card-textContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-around;\n}\n\n\n.card_text {\n\tmargin-bottom: 8px;\n\tfont-size: 12px\n}\n\n.card_text-percentage {\n\tfont-size: 22px;\n\tfont-weight: 700\n}\n\n.dashboard_category-circle {\n\twidth: 300px;\n\theight: 300px;\n\tmargin: auto;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.dasboard_employee-circle {\n\twidth: 260px;\n\theight: 260px\n}\n\n.dashboard_employee-button {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: center;\n\tflex-direction: column;\n}\n\n\n@media (max-width: 1410px) {\n\t.dashboard_cards-container {\n\t\tgrid-template-columns: 1fr 1fr 1fr;\n\t}\n}\n\n@media (max-width: 1300px) {\n\t.dashboard_cards-container {\n\t\tgrid-template-columns: 1fr 1fr;\n\t}\n\n\t.dashboard_hrzone-container {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.dasboard_employee-circle {\n\t\tmargin: auto;\n\t\tmargin-bottom: 30px\n\t}\n\n\t.dashboard_employee-button {\n\t\tmargin: auto;\n\t\tdisplay: block;\n\t\tmargin-top: 30px;\n\t\tmin-width: 200px\n\t}\n}\n\n@media (max-width: 900px) {\n\t.dashboard_cards-container {\n\t\tgrid-template-columns: 1fr 1fr 1fr;\n\t}\n\n\t.dashboard_category-container {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.dashboard_category-circle {\n\t\tmargin: 0 auto 30px auto;\n\t}\n\n\t.dashboard_employee-border {\n\t\tborder-right: none;\n\n\t}\n}\n\n@media (max-width: 768px) {\n\t.dashboard_cards-container {\n\t\tgrid-template-columns: 1fr 1fr;\n\t}\n\n\t.dashboard_employee-container {\n\t\tgrid-template-columns: 1fr;\n\t\tmargin-top: 30px;\n\t}\n\n\t.dashboard_employee-border {\n\n\t\tmargin-bottom: 30px;\n\t}\n}\n\n\n@media (max-width: 550px) {\n\t.dashboard_cards-container {\n\t\tgrid-template-columns: 1fr;\n\t\twidth: 100%\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
